import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useInternationalization } from '../../features/i18n'
import { BasicCard } from '../index'
import Bar from './horizontal-bar-chart-bar'

const HorizontalBarChart = ({data, isLink, pathname = 'organization', queryKey = 'province'}) => {
  const chartData = data
  const { search, pathname: currentPathname } = useLocation()
  const finalPath =
    currentPathname === '/program-statistic' ? '/program' :
    currentPathname === '/organization-statistic' ? '/organization' : undefined
  const { translate } = useInternationalization()

  return (
    <BasicCard>
      <p className="text-lg font-bold font-accent mb-5 uppercase">
        {translate('GENERAL', 'location')}
      </p>
      {
        chartData.data &&
        chartData.data.map((d, index) => (
          <div className="flex justify-between items-center mb-2" key={index}>
            <div className="w-1/2 md:w-1/3 lg:w-full text-sm text-gray-444 pr-2 lg:pr-4">
              {
                isLink ? (
                  <Link className="hover:underline" to={`/${pathname}?${queryKey}=${d.name}`}>
                    {(d.value/chartData.total*100).toFixed(0)}% - {d.name} ({d.value})
                  </Link>
                ) : (
                  <>
                    {(d.value/chartData.total*100).toFixed(0)}% - {d.name} ({d.value})
                  </>
                )
              }
            </div>
            <div className="w-1/2 md:w-2/3 lg:w-full pl-4 lg:pl-0">
              <Bar value={d.value} total={chartData.total}/>
            </div>
          </div>
        ))
      }

      {
        search && finalPath &&
        <div className="mt-8 w-full text-right leading-none">
          <Link className="link" to={finalPath+search}>
            {translate('RELATED', 'view_list')}
          </Link>
        </div>
      }
    </BasicCard>
  )
}

export { HorizontalBarChart }
